<template>
    <div>
        <van-overlay :show="show" :z-index="999999">
            <div class="wrapper">
                <van-loading type="spinner" />
                <div class="font mt-1" style="text-align: center;">{{ $t(title) }}</div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
export default {
    name: "ComLoading",
    props: {
        show:{
            type: Boolean,
            default: false
        },
        title:{
            type: String,
            default: '交易进行中,请勿进行其他操作'
        }
    },
    data() {
        return {};
    },
    methods: {

    },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>